module.exports = __webpack_public_path__ + "img/aurora.19b99993.png";